var _path, _path2, _g, _g2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalanceActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4585 21.6667H4.87516C3.67808 21.6667 2.7085 20.6971 2.7085 19.5V6.50001C2.7085 5.30293 3.67808 4.33334 4.87516 4.33334H12.4585C13.6556 4.33334 14.6252 5.30293 14.6252 6.50001V19.5C14.6252 20.6971 13.6556 21.6667 12.4585 21.6667Z",
    fill: "url(#paint0_linear_4003_409)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7085 19.5V8.66667C2.7085 7.46958 3.67808 6.5 4.87516 6.5H21.1252C22.3222 6.5 23.2918 7.46958 23.2918 8.66667V19.5C23.2918 20.6971 22.3222 21.6667 21.1252 21.6667H4.87516C3.67808 21.6667 2.7085 20.6971 2.7085 19.5Z",
    fill: "url(#paint1_linear_4003_409)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4003_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4585 14.625C12.4585 12.5288 14.1539 10.8333 16.2502 10.8333H22.7502V18.4167H16.2502C14.1539 18.4167 12.4585 16.7213 12.4585 14.625Z",
    fill: "#2F4E96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4003_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14.0833C13 11.9871 14.6954 10.2917 16.7917 10.2917H23.2917V17.875H16.7917C14.6954 17.875 13 16.1796 13 14.0833Z",
    fill: "url(#paint2_linear_4003_409)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.8958C16.4655 14.8958 16.6722 14.8102 16.8245 14.6579C16.9769 14.5055 17.0625 14.2988 17.0625 14.0833C17.0625 13.8679 16.9769 13.6612 16.8245 13.5088C16.6722 13.3564 16.4655 13.2708 16.25 13.2708C16.0345 13.2708 15.8278 13.3564 15.6755 13.5088C15.5231 13.6612 15.4375 13.8679 15.4375 14.0833C15.4375 14.2988 15.5231 14.5055 15.6755 14.6579C15.8278 14.8102 16.0345 14.8958 16.25 14.8958Z",
    fill: "url(#paint3_linear_4003_409)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4003_409",
    x: 11.3752,
    y: 9.75001,
    width: 12.4582,
    height: 9.75001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.541667,
    result: "effect1_foregroundBlur_4003_409"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4003_409",
    x: 13,
    y: 10.2917,
    width: 10.8332,
    height: 8.12501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.541667,
    dy: 0.541667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.541667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4003_409"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_409",
    x1: 8.66683,
    y1: 4.33334,
    x2: 8.66683,
    y2: 8.93751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341346,
    stopColor: "#5C50B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4E96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_409",
    x1: 13.0002,
    y1: 6.5,
    x2: 13.0002,
    y2: 21.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#506EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F4E96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4003_409",
    x1: 19.7708,
    y1: 10.2917,
    x2: 19.7708,
    y2: 17.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D77B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4003_409",
    x1: 16.25,
    y1: 13.2708,
    x2: 16.25,
    y2: 14.8958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceActive);
export default __webpack_public_path__ + "static/media/balanceActive.6316f1e633de29d31661680c61f340b5.svg";
export { ForwardRef as ReactComponent };